import React from "react";
import { Translation } from "react-i18next";

export const ReportsPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      title: (
        <Translation>{(t) => t("navigation.main.user_report")}</Translation>
      ),
      path: "/reports",
      exact: true,
      component: React.lazy(() => import("./Report")),
    },
  ],
};
